// extracted by mini-css-extract-plugin
export default {"teamName":"deleteTeamModal_teamName__beW3E"};